import sanityClient from 'sanityClient';

// •••••••••••••••••••••••••••••••••••••••••••••
// -> GROQ --> Graph-Relational-Object-Queries
// ---------------------------------------
//  A query language developed by Sanity for getting
//  data from Sanity healdless CMS projects.
// ---------------------------------------
// MORE INFO --> https://www.sanity.io/docs/how-queries-work
// •••••••••••••••••••••••••••••••••••••••••••••

export function fetchAboutPageInfo() {
    return sanityClient.fetch(
        `*[_type == 'about'][0]{
            headerText,
            headerVideo,
            bioHeader,
            bio
        }`
    );
}

export function fetchGeneralInfo() {
    return sanityClient.fetch(
        `*[_type == 'general'][0]{
            landingSlogan,
            facebook,
            instagram,
            youtube,
            yandex,
            whatsapp
        }`
    );
}

export function fetchYelpURL() {
    return sanityClient.fetch(
        `*[_type == 'general'][0]{
            yelp,
        }`
    );
}

//---------
// --> VIDEOS
//---------
export function fetchVideos() {
    return sanityClient.fetch(
        `*[_type == 'video']{
            title, 
            embed
        }`
    );
}

//---------
// --> SERVICES
//---------

// Get service slugs for navbars
export function fetchServiceSlugs() {
    return sanityClient.fetch(
        `*[_type == 'service']{
            title,
            slug
        }`
    );
}

// Get Specific Service Content
export function fetchServiceTemplateContent(slug) {
    return sanityClient.fetch(
        `*[slug.current == $slug][0]{
            title,
            body,
            subtitle,
            graphic->{
                img{
                    asset->{
                        url,
                        _id
                    }
                }
            },
            faqs[]-> {
                question,
                answer
            },
            mainImage{
                asset->{
                    url,
                    _id
                }
            }
        }`,
        { slug }
    );
}

//---------
// --> PORTFOLIO ITEMS
//---------

// Get Full Portfolio
export function fetchPortfolioItems() {
    return sanityClient.fetch(
        `*[_type == 'portfolioItem']{
            title, 
            shortSummary,
            slug,
            photos[]{
                asset->{
                    url,
                    _id
                }
            },
            tags[]->{
                title
            },
            services[]->{
                title,
                slug
            },
        }`
    );
}

// Get Specific Portfolio Item
export function fetchPortfolioItem(slug) {
    return sanityClient.fetch(
        `*[slug.current == $slug][0]{
            title, 
            subtitle,
            slug,
            photos[]{
                asset->{
                    url,
                    _id
                }
            },
            faqs[]->{
                question,
                answer
            },
            tags[]->{
                title
            },
            services[]->{
                title,
                slug
            },
            body
        }`,
        { slug }
    );
}

export function fetchProducts() {
    return sanityClient.fetch(
        `*[_type == 'product']{
            title, 
            shortSummary,
            slug,
            photos[]{
                asset->{
                    url,
                    _id
                }
            },
            productType[]->{
                title,
                slug
            },
        }`
    );
}

export function fetchProduct(slug) {
    return sanityClient.fetch(
        `*[slug.current == $slug][0]{
            title, 
            subtitle,
            slug,
            shortSummary,
            photos[]{
                asset->{
                    url,
                    _id
                }
            },
            faqs[]->{
                question,
                answer
            },
            productType[]->{
                title,
                slug
            },
            body
        }`,
        { slug }
    );
}

//----------------------------
// --> Content For Sections
//----------------------------

// Get content for website services section
export function fetchServicesSectionContent() {
    return sanityClient.fetch(
        `*[_type == 'sectionServices'][0]{
            titleTop,
            titleBottom,
            subtitle,
            services {
                serviceOne->{
                    title,
                    shortSummary,
                    slug,
                    mainImage{
                        asset-> {
                            url,
                            _id
                        }
                    }
                },
                serviceTwo->{
                    title,
                    shortSummary,
                    slug,
                    mainImage{
                        asset-> {
                            url,
                            _id
                        }
                    }
                },
                serviceThree->{
                    title,
                    shortSummary,
                    slug,
                    mainImage{
                        asset-> {
                            url,
                            _id
                        }
                    }
                },
                serviceFour->{
                    title,
                    shortSummary,
                    slug,
                    mainImage{
                        asset-> {
                            url,
                            _id
                        }
                    }
                },
            }
        }`
    );
}

// Fetch content for 'Professional Lawn Care' Section on home page
export function fetchProfLawncareContent() {
    return sanityClient.fetch(
        `*[_type == 'sectionProfLawncare'][0]{
            title,
            subtitle,
            body,
            link
        }`
    );
}

export function fetchComments() {
    return sanityClient.fetch(
        `*[_type == 'comments'][0]{
            title,
            subtitle,
            comment,
            name,
              mainImage{
                asset->{
                    url,
                    _id
                }
            }
        }`
    );
}
